import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../../components/withRouter";
import endpoint from "../../../config/endpoints";
import { noInternetMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

const LabelWithShowMore = ({ label, value }) => {
  const [showAll, setShowAll] = React.useState(false);
  const valuesArray = typeof value === "string" ? value.split(",") : [];
  const displayedValues = showAll ? valuesArray : valuesArray.slice(0, 7);
  const shouldShowMore = valuesArray.length > 7;

  return (
    <Grid
      item
      xs={12}
      sm={valuesArray?.length > 7 ? 12 : 6}
      md={valuesArray?.length > 7 ? 12 : 6}
      lg={valuesArray?.length > 7 ? 12 : 6}
    >
      <Box display="flex" alignItems="flex-start">
        <Typography
          variant="body1"
          component="span"
          sx={{
            color: "#39c1d4",
            fontWeight: 500,
            minWidth: "298px",
            flexShrink: 0,
          }}
        >
          {label} :
        </Typography>

        <Box
          sx={{
            display: "inline",
            flex: 1,
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          <Typography
            variant="body1"
            component="span"
            sx={{
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
          >
            {displayedValues.join(", ")}{" "}
          </Typography>

          {shouldShowMore && (
            <Button
              onClick={() => setShowAll(!showAll)}
              size="small"
              sx={{
                textTransform: "none",
                padding: "0px 4px",
                minWidth: "auto",
                fontSize: "12px",
                color: "#39c1d4",
              }}
            >
              {showAll ? "Show Less" : "Show More"}
            </Button>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

class SubAdminUserView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification, params } = this.props;
    if (navigator.onLine) {
      if (params.id) {
        showLoador({ loador: true });
        await apiGet({
          url:
            endpoint.developerAdminUser +
            "/get-by-id?id=" +
            this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            this.setState({ headerData: data.data });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  onCancel = () => {
    this.props.navigate(-1);
  };

  render() {
    const { headerData } = this.state;

    return (
      <Paper sx={{ p: 2, borderRadius: 0 }} elevation={0}>
        <LandingScreenHeader
          screenTitle={"Sub Admin User View"}
          showTable={false}
          showBackButton={true}
          showAddButton={false}
          onCancel={this.onCancel}
        />

        <br></br>

        <Grid container spacing={2}>
          <LabelWithShowMore
            label="Stock Holder Type"
            value={headerData?.stockStakeHolderType?.name || "-"}
          />

          <LabelWithShowMore label="Name" value={headerData?.name || "-"} />

          <LabelWithShowMore
            label="Contact Number"
            value={headerData?.contactNo || "-"}
          />

          <LabelWithShowMore
            label="Email Id"
            value={headerData?.emailId || "-"}
          />

          <LabelWithShowMore
            label="Region"
            value={headerData?.regionNames || "-"}
          />
          <LabelWithShowMore
            label="State"
            value={headerData?.stateNames || "-"}
          />
          <LabelWithShowMore
            label="Zone"
            value={headerData?.zoneNames || "-"}
          />
          <LabelWithShowMore
            label="District"
            value={headerData?.districtNames || "-"}
          />
          <LabelWithShowMore
            label="Taluka"
            value={headerData?.talukaNames || "-"}
          />
          <LabelWithShowMore
            label="Area"
            value={headerData?.areaNames || "-"}
          />
        </Grid>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SubAdminUserView));
